export const calcSalary = (element, payment, team = false) => {
	return (
		Math.round(
			((element.big_items_count - (team ? 0 : element.ignore_bonus_big_items_count || 0)) * payment.delivered_commision +
				(element.small_items_count - (team ? 0 : element.ignore_bonus_small_items_count || 0)) * payment.additional_item_commision) * 100
		) / 100
	);
};
